import script from "./LandingBeauty.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingBeauty.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__